import { makeSideBarActive } from "../../../../utils/EllowUtils"
import SideMenu from "../../sideMenu"
import Styles from "../../styles.module.scss"
import * as CONSTANTS from '../../../../utils/CONSTANTS';
import DashboardHeader from "../../dashboardHeader";
import { useEffect, useState } from "react";
import Headline6 from "../../../../components/headings/Headline6";
import { Link, useNavigate } from "react-router-dom";
import { convertFromRaw } from "draft-js";
import { convertToHTML } from "draft-convert";
import DOMPurify from "dompurify";
import { viewedpageMixpanel } from "../../../../utils/mixpanel";
import { getJobsForCandidate } from "./services";
import Headline5 from "../../../../components/headings/Headline5";

function ReferAndEarn() {

  const menu = makeSideBarActive(CONSTANTS.sideMenuFreelancer, 7)
  // const [selected, setSelected] = useState<number>(0);
  const [jobs, setJobs] = useState<any>()
  const navigate = useNavigate()
  
  const redirectToAvailability = () => {
    // setSelected(2)
  }

  // const profileMetadata = JSON.parse(localStorage.getItem("profile_metadata") || "") || {};

  useEffect(() => {
    viewedpageMixpanel();
    getJobs()
  },[])

  const getJobs = () => {
 
    getJobsForCandidate().then((resp) => {
      if (resp && resp.status === 1) {  
        setJobs(resp.data)
        // let jobs = resp.data.filter((item: any) => { if(item.dummy === false){ return(item)} })     
        // setJobs(jobs)
       }
      //  let jobs = resp.data.filter(function(item: any){
      //   if(item.dummy === false){ return(item)}
      //   else{ return null }
      //  })
      //  setJobs(jobs)
     })
  }

  const createMarkup = (html: any, dummy: boolean) => {

    if (html && html !== '') {
      
      if (html.includes('{"blocks')) {
        let oldblockconverteddata = convertFromRaw(JSON.parse(html));
        let oldblockdataconvertedhtml = convertToHTML(oldblockconverteddata);

        html = JSON.stringify(oldblockdataconvertedhtml);
        return {
          __html: dummy ? DOMPurify.sanitize(html) : html ? DOMPurify.sanitize(html).replace(/"/g, '') : DOMPurify.sanitize(html).replace('"', ''),
        };
      }
      if (html.includes("<p>") || html.includes("<ol") || html.includes("<ul>")) {
        return {
          __html: dummy ? DOMPurify.sanitize(JSON.parse(html)) : html ? DOMPurify.sanitize(JSON.parse(html)).replace(/"/g, '') : DOMPurify.sanitize(JSON.parse(html)).replace('"', ''),
        };
      } else {
        html = "<p>" + html + "</p>";
        return {
          __html: dummy ? DOMPurify.sanitize(html) : html ? DOMPurify.sanitize(html).replace(/"/g, '') : DOMPurify.sanitize(JSON.parse(html)).replace('"', ''),
        };
      }
    }
  }


  return (
    <section className={Styles.dashboardWrapper}>
      <SideMenu menu={menu} />
      <div className={Styles.dashboardContent}>

      <DashboardHeader redirectToAvailability={redirectToAvailability} title={`Refer and earn`}/>
      <div className='contentBox'>
          <div className="innerPadd48">
            <p style={{marginLeft:'10%'}}><Headline5>Refer your friends and earn once they land their first job on ellow!</Headline5></p>
          {(jobs && jobs.length > 0) && jobs.map((job: any, key: number) => {
          return <div  className={Styles.jobCard} key={key}>
            <div  className={Styles.jobData} >
              <div className={Styles.jobTitle}>
                <div className={Styles.subtitle}>Job Role</div>
                <Headline6>{job && job.position}</Headline6>
                <div className={Styles.subtitle}></div>
                 <div className="preview" dangerouslySetInnerHTML={createMarkup(`We are looking for a ${job && job.position}. The Candidate will be reporting directly to team leaders and will be working with cutting-edge technologies on world-class cloud platforms. The company helps businesses to experience noticeable growth by utilizing the tools, tech, and team that help boost ​ROI. This will be a long-term position for developers to experience rapid career growth.`, true)} ></div>
                <div className={Styles.jobDecription}>
                { 
                  <Link to='/referandearn-details' state ={{jobRole: job}}>Read More</Link>
                }   
              </div>
            </div>
            </div>
            <div className={Styles.skillTest}>
                <div>
                  <div className={Styles.subtitle}> </div>
                   <div className={Styles.testItem} key={key}>
                      <button onClick={() => navigate('/referandearn-details',{state:{jobRole: job}, }) }>
                        view
                      </button>
                    </div>
              </div>
            </div>
          </div>
          })} 
            
        </div>
        </div>
        </div>
</section>

  )
}

export default ReferAndEarn